import React, { useState } from 'react';
import { toast } from 'sonner';
import { Plus, Pencil, Trash2, Loader2, Tag, Check, X } from 'lucide-react';
import { Card } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { whatsappAPI } from '../whatsappAPI';
import { useOrganizacao, SeletorCor, Chip } from '../organizacao';

const errMsg = (e, p) => e?.response?.data?.detail || p;

export default function EtiquetasConfig({ admin }) {
  const { etiquetas, recarregar } = useOrganizacao();
  const [edit, setEdit] = useState(null);
  const [salvando, setSalvando] = useState(false);

  const salvar = async () => {
    setSalvando(true);
    try {
      if (edit.id) await whatsappAPI.etiquetaSalvar(edit.id, edit); else await whatsappAPI.etiquetaCriar(edit);
      toast.success(edit.id ? 'Etiqueta atualizada' : 'Etiqueta criada');
      setEdit(null); await recarregar();
    } catch (e) { toast.error(errMsg(e, 'Não foi possível salvar')); }
    finally { setSalvando(false); }
  };
  const excluir = async (et) => {
    if (!window.confirm(`Excluir a etiqueta "${et.nome}"? Ela sai de todas as conversas.`)) return;
    try { await whatsappAPI.etiquetaExcluir(et.id); toast.success('Etiqueta excluída'); recarregar(); }
    catch (e) { toast.error(errMsg(e, 'Não foi possível excluir')); }
  };

  return (
    <Card className="p-5" data-testid="wa-config-etiquetas">
      <div className="flex items-center justify-between gap-2 mb-1">
        <h3 className="font-semibold flex items-center gap-2"><Tag className="w-5 h-5 text-emerald-600" /> Etiquetas</h3>
        {admin && !edit && (
          <Button size="sm" onClick={() => setEdit({ nome: '', cor: '#2563eb', ordem: 0 })} data-testid="wa-etiqueta-nova">
            <Plus className="w-4 h-4 mr-1" /> Nova etiqueta
          </Button>
        )}
      </div>
      <p className="text-xs text-muted-foreground mb-4">
        Marque conversas para encontrar depois (ex.: Cliente VIP, Cobrança, Aguardando retorno). As etiquetas ficam com o
        contato — continuam lá quando um novo atendimento começa. Qualquer atendente aplica; só administradores criam.
      </p>

      {edit && (
        <div className="rounded-xl border-2 border-emerald-200 dark:border-emerald-900 bg-emerald-50/40 dark:bg-emerald-950/20 p-4 mb-4 space-y-3" data-testid="wa-etiqueta-form">
          <div className="flex flex-wrap items-end gap-3">
            <label className="text-sm font-medium flex-1 min-w-[200px]">Nome
              <Input value={edit.nome} onChange={e => setEdit({ ...edit, nome: e.target.value })} maxLength={30} className="mt-1" autoFocus data-testid="wa-etiqueta-nome"
                onKeyDown={e => e.key === 'Enter' && edit.nome.trim() && salvar()} />
            </label>
            <div className="pb-1"><Chip cor={edit.cor}>{edit.nome || 'Prévia'}</Chip></div>
          </div>
          <SeletorCor value={edit.cor} onChange={cor => setEdit({ ...edit, cor })} />
          <div className="flex justify-end gap-2">
            <Button variant="outline" size="sm" onClick={() => setEdit(null)}><X className="w-4 h-4 mr-1" />Cancelar</Button>
            <Button size="sm" onClick={salvar} disabled={salvando || !edit.nome.trim()} className="bg-emerald-600 hover:bg-emerald-700" data-testid="wa-etiqueta-salvar">
              {salvando ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Check className="w-4 h-4 mr-1" />} Salvar
            </Button>
          </div>
        </div>
      )}

      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-2">
        {etiquetas.map(et => (
          <div key={et.id} className="group flex items-center gap-2 px-3 py-2 rounded-lg border">
            <Chip cor={et.cor}>{et.nome}</Chip>
            <span className="flex-1" />
            {admin && (
              <span className="flex opacity-60 group-hover:opacity-100">
                <button onClick={() => setEdit({ ...et })} className="p-1.5 rounded hover:bg-slate-100 dark:hover:bg-slate-800" title="Editar"><Pencil className="w-3.5 h-3.5" /></button>
                <button onClick={() => excluir(et)} className="p-1.5 rounded hover:bg-red-50 dark:hover:bg-red-950/40 text-red-600" title="Excluir"><Trash2 className="w-3.5 h-3.5" /></button>
              </span>
            )}
          </div>
        ))}
      </div>
      {!etiquetas.length && <p className="text-center py-6 text-sm text-muted-foreground">Nenhuma etiqueta.</p>}
    </Card>
  );
}
